import { FunnelConfig } from '~/utils/funnels';

export const SOLAR_LANDSCAPE_FUNNEL_ID = 'solarLandscape';
export const config: FunnelConfig = {
  id: 'solarLandscape',
  path: '/solar-landscape',
  show: () => true,
};
